import { render, staticRenderFns } from "./Readmemd.vue?vue&type=template&id=6d165204&scoped=true"
import script from "./Readmemd.vue?vue&type=script&lang=js"
export * from "./Readmemd.vue?vue&type=script&lang=js"
import style0 from "./Readmemd.vue?vue&type=style&index=0&id=6d165204&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d165204",
  null
  
)

export default component.exports